export default __webpack_public_path__ + "static/media/7.51ab2ad6.png";